import { PlainBlock } from "@/sanity.types";
import { PortableText } from "next-sanity";
import Link from "next/link";

const PlainBlockRenderer = ({ value }: { value: PlainBlock }) => {
	return (
		<div className="[&_ol]:ml-1 [&_ol]:flex [&_ol]:list-decimal [&_ol]:flex-col [&_ol]:gap-y-2 [&_ol]:pl-5 [&_ul]:-mt-4 [&_ul]:mb-4 [&_ul]:ml-1 [&_ul]:list-disc [&_ul]:pl-8">
			<PortableText
				value={value}
				components={{
					types: {},
					block: {
						normal: ({ children }) => (
							<p className="text-body-m sm:text-body-l text-graphite-black/70 mb-5 min-h-4 whitespace-pre-wrap last:mb-0 sm:mb-[1.875rem] sm:min-h-5">
								{children}
							</p>
						),
						h3: ({ children }) => (
							<h3 className="text-h7-mob sm:text-h6 text-graphite-black mb-5 min-h-5 sm:mb-[1.875rem] sm:min-h-[1.875rem] [&:not(:first-child)]:mt-10 [&:not(:first-child)]:sm:mt-0">
								{children}
							</h3>
						),
					},
					marks: {
						strong: ({ children }) => <span className="font-semibold">{children}</span>,
						em: ({ children }) => <em>{children}</em>,
						underline: ({ children }) => <u>{children}</u>,
						"strike-through": ({ children }) => <del>{children}</del>,
						link: ({ value, children }) => {
							const { linkType, href, internalRoute, blank, nofollow } = value;
							const rel = [blank && "noopener", nofollow && "nofollow"].filter(Boolean).join(" ");

							if (linkType === "internal" && internalRoute) {
								return (
									<Link href={internalRoute} className="text-green duration-300 hover:text-black hover:underline">
										{children}
									</Link>
								);
							}

							return (
								<a
									href={href}
									target={blank ? "_blank" : undefined}
									rel={rel || undefined}
									className="text-green duration-300 hover:text-black hover:underline"
								>
									{children}
								</a>
							);
						},
					},
				}}
			/>
		</div>
	);
};

export default PlainBlockRenderer;
